<template>
    <div class="elle-highlights-list">
        <div class="container">
            <div class="list">
                <div v-for="item in highlights" :key="item.id" class="item">
                    <NuxtLink
                        v-if="!!item.linkUrl.length"
                        :to="useConvertedButtonLink(item.linkUrl[0])"
                        :title="item.linkUrl[0].linkText"
                        :target="item.linkUrl[0].newWindow ? '_blank' : '_self'"
                    >
                        <component :is="eqTemplate" :item="item" />
                    </NuxtLink>
                    <component :is="eqTemplate" v-else :item="item" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
defineProps({
    highlights: {
        type: Array,
        default: () => []
    }
});

const isDesktop = useMediaQuery('(min-width: 768px)');
const elRowHighlight = resolveComponent('CardsRowHighlight');
const elRowHighlightMobile = resolveComponent('CardsRowHighlightMobile');

const eqTemplate = computedAsync(() => (isDesktop.value ? elRowHighlight : elRowHighlightMobile));
</script>
